const slideshow = (className, slideNo = -1) => {
  function viewSlide(className, slideNo = -1) {
    let imgArray = document.querySelectorAll(className);
    if (slideNo >= 0) {
      //初回以外は現在のスライドを消す
      imgArray[slideNo].style.opacity = 0;
    }
    slideNo++;
    if (slideNo >= imgArray.length) {
      slideNo = 0; //次のスライドがなければ最初のスライドへ戻る
    }
    imgArray[slideNo].style.opacity = 1;
    if (slideNo === 0) {
      setTimeout(function () {
        viewSlide(className, slideNo);
      }, 1000);
    }
    else if (slideNo === 1) {
      setTimeout(function () {
        viewSlide(className, slideNo);
      }, 1000);
    } else {
      setTimeout(function () {
        viewSlide(className, slideNo);
      }, 4000);
    }
  }
  viewSlide('.how__anim-wrapper img');
}

export default slideshow;